// @ts-check
import { useRef, useCallback } from 'react';

const sessionDurationMs = 60 * 60 * 1000;
const SESSION_LOCAL_STORAGE_KEY = 'custom_ga_session_id';

/**
 * @param {Session} currentSession
 * @returns {Session}
 */
function updateSession(currentSession) {
  const currentTime = new Date().getTime();
  if (currentTime - currentSession.lastActive > sessionDurationMs) {
    return { id: currentTime, lastActive: currentTime };
  } else {
    return { id: currentSession.id, lastActive: currentTime };
  }
}

export default function useMeasurementProtocolSession() {
  const currentTime = new Date().getTime();
  const sessionRef = useRef(
    localStorage.getItem(SESSION_LOCAL_STORAGE_KEY)
      ? /** @type {Session} */ (JSON.parse(localStorage.getItem(SESSION_LOCAL_STORAGE_KEY)))
      : /** @type {Session} */ ({ id: currentTime, lastActive: currentTime })
  );

  /** @param {Session} newSession */
  const setSession = (newSession) => {
    sessionRef.current = newSession;
    localStorage.setItem(SESSION_LOCAL_STORAGE_KEY, JSON.stringify(newSession));
  };

  const getSession = useCallback(() => {
    setSession(updateSession(sessionRef.current));
    return sessionRef.current;
  }, []);

  setSession(updateSession(sessionRef.current));

  return getSession;
}

/**
 * @typedef Session
 * @property {number} id
 * @property {number} lastActive
 */
